import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useT } from "../lib/i18n";

/** Owner authorisations + contracts of sale (ID numbers come masked from the API). */
export default function ShowroomFormsList() {
  const { t } = useT();
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/showroom-forms").then(({ data }) => setItems(data.items || [])).catch(() => {}); }, []);
  return (
    <div className="panel overflow-x-auto" data-testid="sf-list">
      <div className="p-3 font-semibold">{t("sf.showroom_forms")}</div>
      {items.length === 0 ? <div className="p-3 text-sm opacity-60">{t("sf.none")}</div> : (
        <table className="w-full text-sm">
          <tbody>
            {items.map((f) => (
              <tr key={f.id} className="border-t cursor-pointer" onClick={() => nav(`/forms/sf/${f.id}`)} data-testid={`sf-row-${f.id}`}>
                <td className="p-3" dir="ltr">{f.reference}</td>
                <td>{f.form_type === "owner_auth" ? t("sf.owner_title") : t("sf.contract_title")}</td>
                <td>{f.data?.owner_name || f.data?.buyer_name}</td>
                <td dir="ltr">{f.data?.owner_civil_id || f.data?.buyer_civil_id || ""}</td>
                <td>{f.vehicle_label || `${f.data?.make || f.data?.vehicle_type || ""} ${f.data?.model || ""}`}</td>
                <td>{t(`sf.status_${String(f.status).toLowerCase() /* i18n-keys: draft,signed,completed,voided */}`)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
